import { min_value as minValue } from 'vee-validate/dist/rules';

export default {
  ...minValue,
  validate: (value, { min }) => {
    if (typeof min === 'string' && min.indexOf('currentYear') > -1) {
      const currentYear = new Date().getFullYear();

      if (min === 'currentYear') {
        return Number(value) >= currentYear;
      }

      const plusYear = min.split(' + ')[1];
      const minusYear = min.split(' - ')[1];
      const diff = Number(plusYear) || -Number(minusYear);
      return Number(value) >= currentYear + diff;
    }

    return minValue.validate(value, { min });
  },
  params: ['min'],
};
